import React, { useContext, useState } from "react"; // Import useState
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { AuthContext } from "../../context/AuthContext";
import styles from "../AuthComponents/auth.module.css";
import CircularLoader from "../CircularLoader/CircularLoader";
import { toast } from "react-toastify";

const CheckoutForm = ({ onNext, formData }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { signUp } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      console.error("Stripe.js has not yet loaded.");
      return;
    }

    setIsLoading(true);

    const result = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });

    setIsLoading(false);

    if (result.error) {
      console.error(result.error.message);
      toast.error("Error Processing Payment");
    } else {
      if (result.paymentIntent.status === "succeeded") {
        console.log("Payment Succeeded!");
        try {
          await signUp(formData);
          toast.success("Payment Succeeded!");
          onNext();
        } catch (error) {
          console.error("Payment Processing Failed", error);
          toast.error("Payment Processing Failed");
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {isLoading ? (
        <div className={styles.pay_button}>
          <CircularLoader />
        </div>
      ) : (
        <button
          type="submit"
          disabled={!stripe || isLoading}
          className={styles.pay_button}
        >
          Complete Purchase
        </button>
      )}
    </form>
  );
};

export default CheckoutForm;
